import type { LayerStyles } from "@yamada-ui/core"

export const layerStyles: LayerStyles = {}
